import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Lightbox } from 'rp-bloodstock-search';

export default function ShortlistFailureLightbox({ open, onClose }) {
    return (
        <Lightbox
            open={open}
            onClose={onClose}
        >
            <div className="catalogueShortlistFailureLightbox__wrap">
                <h2 className="catalogueShortlistFailureLightbox__title">
                    Something's gone wrong and your shortlist has not been updated
                </h2>
                <p className="catalogueShortlistFailureLightbox__text">
                    Reclick the star icon to start again
                </p>
                <button
                    className={classnames(
                        'ui-btn',
                        'ui-btn_primary',
                        'ui-btn_large',
                        'catalogueShortlistFailureLightbox__button',
                    )}
                    onClick={onClose}
                >
                    ok
                </button>
            </div>
        </Lightbox>
    );
}

ShortlistFailureLightbox.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/js/components/Shortlist/ShortlistFailureLightbox.js